import './logo.css';
import headerLogo from '../../utils/imgs/logos/yellow_logo.png';
import footerLogo from '../../utils/imgs/logos/white-logo.png';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Logo = ({ header, links, setLinks }) => {

    /* ------ Context API ------ */
    const { selectedLanguage, changeLanguage } = useLanguage();

    const srcAndClass = {
        class : header ? "logo-header" : "logo-footer",
        src   : header ?  headerLogo   :  footerLogo  ,
        flag  : header ? "header-flag" : "footer-flag"
    };

    const unselectGalleriaButton = () => {
        window.scrollTo(0, 0);
        const newLinks = links?.map(link => ({ ...link, hasFocused: false }));
        setLinks(newLinks);
    };

    return (
        <div className={srcAndClass?.class}>

            <div onClick={unselectGalleriaButton}>
                <Link to="/">
                    <img src={srcAndClass?.src} alt="logo" />
                </Link>
            </div>
                        
            <p className={srcAndClass?.flag} onClick={changeLanguage} >
                {selectedLanguage === "ita" ? "🇬🇧 EN" : "🇮🇹 ITA"}
            </p>

        </div>
    );
}

export default Logo;